import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CircularWarning = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 16, height: 16, fill: 'none', ...props.sx }}
    data-testid="warningIcon"
    titleAccess="warning"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="#FEB3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00342 11.2615C9.00342 11.8166 8.55341 12.2666 7.99829 12.2666C7.44317 12.2666 6.99316 11.8166 6.99316 11.2615C6.99316 10.7064 7.44317 10.2563 7.99829 10.2563C8.55341 10.2563 9.00342 10.7064 9.00342 11.2615ZM7.99829 8.69737C6.99642 8.69737 6.99316 5.11341 6.99316 4.7384C6.99316 4.18328 7.44317 3.73327 7.99829 3.73327C8.55341 3.73327 9.00342 4.18328 9.00342 4.7384C9.00342 5.11341 9.00016 8.69737 7.99829 8.69737Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default CircularWarning;
